import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import Text from '@dbh/text';
import { SignUpLink } from '@dbh/user-area-components';

var _Text;const intlFormatterValuesSignup={linkComponent:/*#__PURE__*/_jsx(SignUpLink,{})},SignUpTextWithLink=/*#__PURE__*/memo(()=>_Text||(_Text=/*#__PURE__*/_jsx(Text,{size:"ff7",intlFormatter:!0,intlFormatterValues:intlFormatterValuesSignup},void 0,"components.FormSignIn.text_with_link_signup")));SignUpTextWithLink.displayName="SignUpTextWithLink";var SignUpTextWithLink$1 = SignUpTextWithLink;

export { SignUpTextWithLink$1 as S };
